import { SPREAD_SIZE } from '@studio/shared';
import { api } from './api.js';
import { useAsync } from './useAsync.js';

/**
 * How many Candidates one Generate / Explore press queues.
 *
 * A subscription image source runs one image at a time, so the Studio matches Store
 * Design and asks for one Candidate per press rather than the ordinary six.
 */
export function useSpreadSize(): number {
  const providers = useAsync(async () => api.readProviders(), []);
  const source = providers.value?.imageSource;
  return source === undefined || source === null ? SPREAD_SIZE : 1;
}
